var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
import { Roles, SubscriptionTiers } from './AdminConstants';
export var Permissions = {
    ADD_GAME: 'ADD_GAME',
    ADVANCED_SCORING: 'ADVANCED_SCORING',
    SCORE: 'SCORE',
    VIEW_CUSTOM_GAMES: 'VIEW_CUSTOM_GAMES'
};
export var Rules = (_a = {},
    _a[Permissions.ADD_GAME] = (_b = {},
        _b[SubscriptionTiers.FREE] = (_c = {},
            _c[Roles.ADMINISTRATOR] = false,
            _c[Roles.SALESPERSON] = false,
            _c),
        _b[SubscriptionTiers.BASIC] = (_d = {},
            _d[Roles.ADMINISTRATOR] = true,
            _d[Roles.SALESPERSON] = false,
            _d),
        _b[SubscriptionTiers.BUSINESS] = (_e = {},
            _e[Roles.ADMINISTRATOR] = true,
            _e[Roles.SALESPERSON] = false,
            _e),
        _b),
    _a[Permissions.ADVANCED_SCORING] = (_f = {},
        _f[SubscriptionTiers.FREE] = (_g = {},
            _g[Roles.ADMINISTRATOR] = false,
            _g[Roles.SALESPERSON] = false,
            _g),
        _f[SubscriptionTiers.BASIC] = (_h = {},
            _h[Roles.ADMINISTRATOR] = false,
            _h[Roles.SALESPERSON] = false,
            _h),
        _f[SubscriptionTiers.BUSINESS] = (_j = {},
            _j[Roles.ADMINISTRATOR] = true,
            _j[Roles.SALESPERSON] = false,
            _j),
        _f),
    _a[Permissions.SCORE] = (_k = {},
        _k[SubscriptionTiers.FREE] = (_l = {},
            _l[Roles.ADMINISTRATOR] = true,
            _l[Roles.SALESPERSON] = true,
            _l),
        _k[SubscriptionTiers.BASIC] = (_m = {},
            _m[Roles.ADMINISTRATOR] = true,
            _m[Roles.SALESPERSON] = true,
            _m),
        _k[SubscriptionTiers.BUSINESS] = (_o = {},
            _o[Roles.ADMINISTRATOR] = true,
            _o[Roles.SALESPERSON] = true,
            _o),
        _k),
    _a[Permissions.VIEW_CUSTOM_GAMES] = (_p = {},
        _p[SubscriptionTiers.FREE] = (_q = {},
            _q[Roles.ADMINISTRATOR] = false,
            _q[Roles.SALESPERSON] = false,
            _q),
        _p[SubscriptionTiers.BASIC] = (_r = {},
            _r[Roles.ADMINISTRATOR] = true,
            _r[Roles.SALESPERSON] = true,
            _r),
        _p[SubscriptionTiers.BUSINESS] = (_s = {},
            _s[Roles.ADMINISTRATOR] = true,
            _s[Roles.SALESPERSON] = true,
            _s),
        _p),
    _a);
export default {
    Permissions: Permissions,
    Rules: Rules
};
